import { Box, Button, Grid2, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const EditStep1 = ({ tender, setTender, user, setStep }) => {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setTender({ ...tender, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = tender || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    const now = new Date();

    const purchaseDate = data.tenderPurchaseDate
      ? new Date(data.tenderPurchaseDate)
      : null;
    const publishDate = data.tenderPublishDate
      ? new Date(data.tenderPublishDate)
      : null;
    const bidStart = data.bidSubmissionStartDate
      ? new Date(data.bidSubmissionStartDate)
      : null;
    const bidEnd = data.bidSubmissionEndDate
      ? new Date(data.bidSubmissionEndDate)
      : null;
    const bidOpen = data.bidOpeningDate ? new Date(data.bidOpeningDate) : null;

    if (isEmpty(data.title)) newErrors.title = "Title is required";
    if (isEmpty(data.shortDesc))
      newErrors.shortDesc = "Short Description is required";
    if (isEmpty(data.longDesc)) {
      newErrors.longDesc = "Long Description is required";
    } else if(data.longDesc.length > 1000){
      newErrors.longDesc = "Long Description should be upto 1000 characters";
    }
    if (!purchaseDate) {
      newErrors.tenderPurchaseDate = "Purchase Date is required";
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (purchaseDate < today) {
        newErrors.tenderPurchaseDate = "Purchase Date cannot be in the past";
      }
    }

    if (!publishDate) {
      newErrors.tenderPublishDate = "Publish Date is required";
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (publishDate < today) {
        newErrors.tenderPublishDate = "Publish Date cannot be in the past";
      }
    }

    if (!bidStart) {
      newErrors.bidSubmissionStartDate = "Start Date & Time is required";
    } else if (bidStart < now) {
      newErrors.bidSubmissionStartDate =
        "Start Date & Time cannot be in the past";
    } else {
      publishDate.setHours(0, 0, 0, 0)
      if (bidStart <= publishDate) {
        newErrors.bidSubmissionStartDate =
          "Start Date & Time must be after Tender Publish Date";
      }
    }
    if (!bidEnd) {
      newErrors.bidSubmissionEndDate = "End Date & Time is required";
    } else if (bidEnd < now) {
      newErrors.bidSubmissionEndDate = "End Date & Time cannot be in the past";
    } else if (bidStart && bidEnd < bidStart) {
      newErrors.bidSubmissionEndDate =
        "End Date & Time must be after Start Date & Time";
    }

    if (!bidOpen) {
      newErrors.bidOpeningDate = "Bid Opening Date & Time is required";
    } else if (bidOpen < now) {
      newErrors.bidOpeningDate =
        "Bid Opening Date & Time cannot be in the past";
    } else if (bidEnd && bidOpen < bidEnd) {
      newErrors.bidOpeningDate = "Bid Opening must be after Bid Submission End";
    }

    if (isEmpty(data.bidOfferValidity))
      newErrors.bidOfferValidity = "Offer Validity is required";
    if (isEmpty(data.deptName))
      newErrors.deptName = "Department Name is required";
    if (isEmpty(data.contactEmail)) {
      newErrors.contactEmail = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.contactEmail)) {
      newErrors.contactEmail = "Enter a valid email";
    }
    if (isEmpty(data.itemCategory))
      newErrors.itemCategory = "Item Category is required";
    if (isEmpty(data.contractPeriod))
      newErrors.contractPeriod = "Contract Period is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (!validateForm()) return;
    setStep((prev) => prev + 1);
  };

  const handleBack = () => {
    navigate("/dashboard");
  };
  return (
    <div>
      <h2>Edit Tender</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "16%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Tender Details</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="title">Title</label>
            <input
              className={`${errors.title && "input-error"}`}
              type="text"
              id="title"
              name="title"
              onChange={handleChange}
              value={tender && tender.title}
            />
            {errors.title && <p className="error">{errors.title}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="shortDesc">Short Description</label>
            <input
              className={`${errors.shortDesc && "input-error"}`}
              type="text"
              id="shortDesc"
              name="shortDesc"
              onChange={handleChange}
              value={tender && tender.shortDesc}
            />
            {errors.shortDesc && <p className="error">{errors.shortDesc}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="longDesc">Long Description</label>
            <textarea
              className={`${errors.longDesc && "input-error"}`}
              id="longDesc"
              name="longDesc"
              rows="4"
              onChange={handleChange}
              value={tender && tender.longDesc}
            ></textarea>
            {errors.longDesc && <p className="error">{errors.longDesc}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="tenderPurchaseDate">Tender Purchase Date</label>
            <input
              className={`${errors.tenderPurchaseDate && "input-error"}`}
              type="date"
              id="tenderPurchaseDate"
              name="tenderPurchaseDate"
              onChange={handleChange}
              value={tender && tender.tenderPurchaseDate}
            />
            {errors.tenderPurchaseDate && (
              <p className="error">{errors.tenderPurchaseDate}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="tenderPublishDate">Tender Publish Date</label>
            <input
              className={`${errors.tenderPublishDate && "input-error"}`}
              type="date"
              id="tenderPublishDate"
              name="tenderPublishDate"
              onChange={handleChange}
              value={tender && tender.tenderPublishDate}
            />
            {errors.tenderPublishDate && (
              <p className="error">{errors.tenderPublishDate}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="bidSubmissionStartDate">
              Bid Submission Start Date
            </label>
            <input
              className={`${errors.bidSubmissionStartDate && "input-error"}`}
              type="datetime-local"
              id="bidSubmissionStartDate"
              name="bidSubmissionStartDate"
              onChange={handleChange}
              value={tender && tender.bidSubmissionStartDate}
            />
            {errors.bidSubmissionStartDate && (
              <p className="error">{errors.bidSubmissionStartDate}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="bidSubmissionEndDate">
              Bid Submission End Date
            </label>
            <input
              className={`${errors.bidSubmissionEndDate && "input-error"}`}
              type="datetime-local"
              id="bidSubmissionEndDate"
              name="bidSubmissionEndDate"
              onChange={handleChange}
              value={tender && tender.bidSubmissionEndDate}
            />
            {errors.bidSubmissionEndDate && (
              <p className="error">{errors.bidSubmissionEndDate}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="bidOpeningDate">Bid Opening Date</label>
            <input
              className={`${errors.bidOpeningDate && "input-error"}`}
              type="datetime-local"
              name="bidOpeningDate"
              onChange={handleChange}
              value={(tender && tender.bidOpeningDate) || ""}
            />
            {errors.bidOpeningDate && (
              <p className="error">{errors.bidOpeningDate}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="bidOfferValidity">
              Bid Offer Validity (From End Date) (In Days)
            </label>
            <input
              className={`${errors.bidOfferValidity && "input-error"}`}
              type="number"
              id="bidOfferValidity"
              name="bidOfferValidity"
              onChange={handleChange}
              value={tender && tender.bidOfferValidity}
            />
            {errors.bidOfferValidity && (
              <p className="error">{errors.bidOfferValidity}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="deptName">Department Name</label>
            <input
              className={`${errors.deptName && "input-error"}`}
              type="text"
              id="deptName"
              name="deptName"
              onChange={handleChange}
              value={tender && tender.deptName}
            />
            {errors.deptName && <p className="error">{errors.deptName}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="contactEmail">Contact Person Email</label>
            <input
              className={`${errors.contactEmail && "input-error"}`}
              type="email"
              id="contactEmail"
              name="contactEmail"
              onChange={handleChange}
              value={tender && tender.contactEmail}
            />
            {errors.contactEmail && (
              <p className="error">{errors.contactEmail}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="itemCategory">Item Category</label>
            <input
              className={`${errors.itemCategory && "input-error"}`}
              type="text"
              id="itemCategory"
              name="itemCategory"
              onChange={handleChange}
              value={tender && tender.itemCategory}
            />
            {errors.itemCategory && (
              <p className="error">{errors.itemCategory}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="contractPeriod">Contract Period (In Months)</label>
            <input
              className={`${errors.contractPeriod && "input-error"}`}
              type="number"
              id="contractPeriod"
              name="contractPeriod"
              onChange={handleChange}
              value={tender && tender.contractPeriod}
            />
            {errors.contractPeriod && (
              <p className="error">{errors.contractPeriod}</p>
            )}
          </Grid2>
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button className="btn-contained" onClick={handleNext}>
          Next
        </Button>
      </Box>
    </div>
  );
};

export default EditStep1;
